import React, { useMemo } from "react";
import Snowfall from "react-snowfall";

function isHolidaySeason() {
  const now = new Date();
  const month = now.getMonth(); // 0=Jan, 11=Dec
  const day = now.getDate();
  return (month === 11 && day >= 15) || (month === 0 && day <= 5);
}

const layerBase: React.CSSProperties = {
  position: "fixed",
  inset: 0,
  zIndex: 9999,
  pointerEvents: "none",
};

export default function SnowfallOnly() {
  const showSnow = useMemo(() => isHolidaySeason(), []);
  if (!showSnow) return null;

  const base = window.innerWidth < 768 ? 60 : 120;

  return (
    <>
      {/* ❄️ White snow (main layer) */}
      <div
        style={{
          ...layerBase,
          filter: "drop-shadow(0 0 2px rgba(0,0,0,0.45))",
          opacity: 0.95,
        }}
      >
        <Snowfall snowflakeCount={base} />
      </div>

      {/* 🌸 Light Pink */}
      <div
        style={{
          ...layerBase,
          background: "rgba(255, 182, 193, 0.08)", // light pink
          mixBlendMode: "multiply",
          opacity: 0.35,
        }}
      >
        <Snowfall snowflakeCount={Math.round(base * 0.25)} />
      </div>

      {/* 💙 Light Blue */}
      <div
        style={{
          ...layerBase,
          background: "rgba(173, 216, 230, 0.08)", // light blue
          mixBlendMode: "multiply",
          opacity: 0.35,
        }}
      >
        <Snowfall snowflakeCount={Math.round(base * 0.25)} />
      </div>

      {/* 🌿 Light Green */}
      <div
        style={{
          ...layerBase,
          background: "rgba(180, 238, 180, 0.08)", // light green
          mixBlendMode: "multiply",
          opacity: 0.3,
        }}
      >
        <Snowfall snowflakeCount={Math.round(base * 0.2)} />
      </div>
    </>
  );
}
